import "./Category.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import NavBar from "./NavBar";

import DetailsTea from "./DetailsTea";
import DetailsCoffee from "./DetailsCoffee";
import DetailsSweets from "./DetailsSweets";

function Category() {
  const params = useParams();
  const [category, setCategory] = useState([]);
  const [categoryNumber, setCategoryNumber] = useState("");

  useEffect(() => {
    const categories = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACK}/${params.id}`
      );

      setCategory(response.data);
      setCategoryNumber(response.data[0].categoryId);
      // console.log(response.data[0].categoryId);
    };
    categories();
  }, [params.id]);

  return (
    category.length > 0 && (
      <div className="container pt-5">
        <NavBar />
        <h3 className="fw-bold mt-5  h1">
          {category[0].category.name.toUpperCase()}
        </h3>
        <hr />

        <div className="row">
          {category.map((item) => {
            return (
              <div key={item.id} className="col-sm-12 col-md-6 col-lg-4 mt-3">
                <Link to={`/product/${item.slug}`}>
                  <img
                    src={`
                    ${process.env.REACT_APP_FILES_URL}/${item.image}
                  `}
                    className="rounded float-start ps-3 pe-3 w-100 zoom"
                    alt="..."
                  />
                </Link>
                <h4 className="fw-bold">{item.name}</h4>
                <h5>US$ {item.price}</h5>
              </div>
            );
          })}
        </div>
        {categoryNumber === "1" && <DetailsCoffee />}
        {categoryNumber === "2" && <DetailsTea />}
        {categoryNumber === "3" && <DetailsSweets />}
      </div>
    )
  );
}

export default Category;
